<template>
    <div  >
        <div > 
            <form @submit.prevent="periodic_submit" v-if="stateForm==0">
                <table class="table text-center font-weight-light table-borderless"  >
                     <tr>
                        <td style="text-align: left; font-weight: bold;">Nom de l'alarme :</td>
                    </tr>
                    <tr>
                        <td COLSPAN="3">
                          
                            <input type="text" id="name" class="form-control border-color not-allowed " v-model="alarme.alarm_name"
                               @keypress="check_name($event)"
                                placeholder="Entrer le nom de l'alarme"  
                                minlength="1" 
                                maxlength="255" 
                                required
                                pattern="[a-zA-ZÀ-ÿ][a-zA-ZÀ-ÿ0-9 ]*"
                                title="Commencer par une lettre avec ou sans accent et entrer par la suite lettres, chiffres ou espace"
                            >
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: left; font-weight: bold;">Destinataire :</td>
                    </tr>
                    <tr>
                        <td COLSPAN="3">
                            <select v-model="alarme.dest_id" class="form-control" 
                                required>
                                <option disabled v-bind:value="null" selected>Choisissez le Destinataire</option>
                                <option v-for="group in adherents" v-bind:value="group.id" v-bind:key="group.id">
                                {{ group.fullname + ' '+ '('+ group.code + ')'}}
                                </option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td style="text-align: left; font-weight: bold;">Periodicité :</td> 
                        <td style="text-align: left; font-weight: bold;">Type d'unité :</td> 
                        <td v-if="alarme.unit_type === '2'|| alarme.unit_type === 2|| alarme.unit_type === 3|| alarme.unit_type === '3'" style="text-align: left; font-weight: bold;">Ref valeur:</td> 
                        <td v-if="alarme.unit_type === '1'|| alarme.unit_type === 1" style="text-align: left; font-weight: bold;">Ref date:</td> 
                    </tr>
                    <tr>
                        <td class="align-middle">
                            <input type="text" id="period" class="form-control border-color not-allowed " v-model="alarme.periodicity" 
                                @keypress="check_input($event)"
                                placeholder="Entrer une valeur" 
                                required 
                                minlength="1" 
                                maxlength="10"
                                pattern="^(?=.*[1-9])[0-9]*$|[1-9][0-9]*|^([0-9]*)[1-9]$"
                                title= "Saisir un nombre entier different de 0"
                            >
                        </td>
                        <td >
                            <select v-model="alarme.unit_type"  class="form-control " required  >
                                <option disabled v-bind:value="null" selected>Choisissez un type d'unité</option>
                                <option value= '1' > jours </option>
                                <option value= '2' >{{ this.unit_t }} </option>
                                <option value= '3' > heures (h) </option>
                            </select>
                        </td>
                        <td v-if="alarme.unit_type === '2'||alarme.unit_type === 2 || alarme.unit_type === 3 || alarme.unit_type === '3'" class="align-middle">
                            <input type="text" id="ref_val" class="form-control border-color not-allowed " v-model="alarme.ref_val" 
                                @keypress="check_refVal($event)"
                                placeholder="Entrer une valeur" 
                                required 
                                minlength="1" 
                                maxlength="10"
                                pattern= "^\d+(\.\d{1,2})?$"
                                title= "Saisir un nombre entier ou un décimal avec 2 chiffres maximum après la virgule et au moins 1 chiffre avant la virgule"
                            >
                        </td>
                        <td v-if="alarme.unit_type === '1' || alarme.unit_type === 1" class="align-middle">
                            <input type="date" id="ref_date" class="form-control border-color not-allowed " v-model="alarme.ref_date" 
                             required  
                             min="1970-01-01" 
                             max="2038-01-19" 
                            >
                        </td>
                    </tr>
                    <tr>
                        <td  class="align-middle" colspan="3">
                            <div  class="text-center mt-4" >
                                <b-button class="btn btn-default mr-3" :disabled="isBusy" @click="$emit('periodic-config-done',{'error' : true,})">Annuler</b-button>
                                <!-- <b-button class="btn btn-default mr-3" variant="secondary" :disabled="isBusy" @click="annuler()"> Annuler </b-button>-->
                                <b-button  type="submit" class="btn btn-primary"> Valider </b-button>
                            </div>
                            <div class="alert alert-danger" role="alert" v-if="error">
                                Impossible d'ajouter une alarme periodique ! Veuillez contacter KEMTAG
                                <i class="ti-close float-right mt-1" @click="error = false"></i>
                            </div> 
                        </td>
                    </tr>
                </table>
            </form>
        </div>
    </div>
</template>

<script>
import api from "../../config/_api";
import { mapGetters } from 'vuex';
import { mapState } from 'vuex';
import axios from 'axios';

export default {
    name :"PeriodicConfig",
    data () {
        return {
            unit: null,
            unit_t: null,
			isBusy: false,    
            error: false, // initialiser l'objet error {pour la fonction alerte}     
            stateForm :0,
            initialName: null,
            initialDest: 0,
            initialPeriodic: 0,
            initialUnit_type: 0,
            alarme:{
                id :0,
                alarm_name: null,
                unit_type: null,
                dest_id: null,
                periodicity: null,
                ref_val : 0,
                ref_date : null,
            }
        }
    },
    props :{
        selected_system: {
            type: Object,
            required: false
        },
        periodic_alarm : {
            type: Object,
            required: false
        },
        action : ""
    },
    computed :{
        ...mapGetters({
            adherents: 'adherents/adherents',
        }),
    },
     created(){
        this.unite();
        this.setValues();
        if ((this.periodic_alarm.unit_type ==2)||(this.periodic_alarm.unit_type ==3)){
                this.alarme.ref_val = this.periodic_alarm.ref_val;
            }
            else if (this.periodic_alarm.unit_type ==1){
                this.alarme.ref_date = this.periodic_alarm.ref_date;
            }
    },
    
    mounted (){
        //this.$store.dispatch('system_alarm_periodic/getSysAlarm');
        this.$store.dispatch('adherents/getAdherents');
       //fonctionne correctement
        if (this.periodic_alarm) {

            this.alarme.id = this.periodic_alarm.id;
            this.alarme.alarm_name = this.periodic_alarm.alarm_name;
            this.alarme.unit_type = this.periodic_alarm.unit_type;
            this.alarme.periodicity = this.periodic_alarm.periodicity;
            if ((this.periodic_alarm.unit_type ==2)||(this.periodic_alarm.unit_type ==3)){
                this.alarme.ref_val = this.periodic_alarm.ref_val;

            }
            else if (this.periodic_alarm.unit_type ==1){
                //this.alarme.ref_date = new Date(this.periodic_alarm.ref_date);
                this.alarme.ref_date = this.periodic_alarm.ref_date.substring(0, 10);
                //this.alarme.ref_date = this.periodic_alarm.ref_date;
                console.log(this.alarme.ref_date);
            }
            this.alarme.dest_id = this.periodic_alarm.dest_id;
        }
    },


    methods : {
        periodic_submit() {
            this.periodicity = document.getElementById("period").value;
            this.alarm_name = document.getElementById("name").value;
            if((this.alarme.unit_type == 2 )||(this.alarme.unit_type == 3 )){
                this.ref_val = document.getElementById("ref_val").value;
                this.ref_date = "";
            }
            else if(this.alarme.unit_type == 1 ){
                this.ref_date = document.getElementById("ref_date").value;
                this.ref_val = 0;
            }
            
            this.dest_id= this.alarme.dest_id;

           //si l'alarme existe déjà sur le system faire un update lorsqu'on valide
            //verifier si computed_alarme.id! =0 alarme sur le system existe
                if(this.alarme.id!=0){
                    this.$store.dispatch('system_alarm_periodic/update', {
                        id: this.alarme.id,
                        unit_type: this.alarme.unit_type,
                        dest_id: this.dest_id,
                        periodicity: this.periodicity,
                        ref_val: this.ref_val,
                        ref_date: this.ref_date,
                        alarm_name: this.alarm_name
					}).then(resp => {
                        this.$emit('periodic-config-done',{'error' : false,'resp' : resp});
                    }).catch((error) => {
                        this.error = true;
                    })
                }
                else {
                     this.$store.dispatch('system_alarm_periodic/create', {
                        system_id: this._props.selected_system.id,
                        unit_type: this.alarme.unit_type,
                        dest_id: this.dest_id,
                        periodicity: this.periodicity,
                        ref_val: this.ref_val,
                        ref_date: this.ref_date,
                        alarm_name: this.alarm_name
					}).then(resp => {
                        this.$emit('periodic-config-done',{'error' : false,'resp' : resp});
                    }).catch((error) => {
                        this.error = true;
                    })
                }
   
        },
        unite(){
            if(this.selected_system!=null){
                var unit_t = null;
                //this.unit = this.selected_system.status;
                this.$store.dispatch('display_unit/getUnit', {
					id: this._props.selected_system.display_unit_id,
				}).then(resp => {
                    const unit = resp.title;
                    this.setValues(unit);
				}).catch((error) => {
					this.error = true; 
                    //console.log(err);
                })
                // condition pour mettre à jour unit_type en fonction des differents unit(0 à 6) et l'utiliser comme vmodel de la permière option        
            }
        },
        setValues(unit){
            if(unit=='0'){
                this.unit_t= 'unités';
            }
            else if(unit=='1'){
                this.unit_t= 'hectares';
            }
            else if(unit=='2'){
                this.unit_t= 'kilomètres';
            }
            else if(unit=='3'){
                this.unit_t= 'contacts';
            }
            else if(unit=='4'){
                this.unit_t= 'heures';
            }
            else if(unit=='5'){
                this.unit_t= 'Kwh';
            }
            else if(unit=='6'){
                this.unit_t= 'm³';
            }
            else if(unit=='7'){
                this.unit_t= 'kg';
            }
        },

        //empêche la saisie de 0 comme 1er chiffre et n'autorise pas une valeur >  4 294 967 295 ( 2 exp 32-1)
        check_input: function(event){
            var input = event.target;
            
            var value = parseInt(input.value + event.key);
           
            if (isNaN(value) || value >  4294967295) {
                event.preventDefault();
            } 
             else if (input.value === "" && event.key === "0") {
                event.preventDefault();
             }
            //else if (input.value === "" || input.value !== "0") {
            else if (input.value === "" || input.value !== "0" || input.value == "0") {
                if( event.keyCode < 48 ||  event.keyCode > 57 ) event.returnValue = false;
                if( event.which < 48 ||  event.which > 57  ) return false;
            }
           
            else {
                event.preventDefault();
            }
        },
      
        check_refVal: function(event){
           // autoriser les chiffres et le signe moins et les nombres décimaux
            if (((event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode === 46) || ((event.which >= 48 && event.which <= 57) || event.which === 46)) {
                // autoriser la saisie de chiffres ou d'un seul point si le point n'est pas déjà présent
                if (event.keyCode === 46 || event.which === 46) {
                    if (event.target.value.indexOf('.') === -1) {
                        return true;
                    } else {
                        event.preventDefault();
                        return false;
                    }
                }
                return true;
            }

            // empêcher toutes les autres touches
            event.preventDefault();
            return false;
        },
        
        check_name(event) {
            var input = event.target;
            var value = input.value + event.key;
            var hasLetter =/[a-zA-ZÀ-ÿ]/.test(input.value); // Vérifie s'il y a au moins une lettre dans le champ
            var haschiffre = /[0-9]/.test(input.value); // Vérifie s'il y a au moins un chiffre dans le champ

            if ((hasLetter)||(!hasLetter && haschiffre)) {
                // Si au moins une lettre est déjà saisie, autoriser la saisie de lettres et de chiffres et d'espaces
               
                if (/^[a-zA-ZÀ-ÿ0-9\s]*$/.test(value)) {
                    return true;
                }
            } else {
                // Si aucune lettre n'est saisie, empêcher la saisie de chiffres
                if (/^[a-zA-ZÀ-ÿ]*$/.test(value)) {
                    return true;
                }
            }
            event.preventDefault();
        },
    }
}

</script>
